import { jsPDF } from 'jspdf';
import { getCurrencySymbol } from './currency';

export const generatePRD = (prdData) => {
  const { project, client, freelancer } = prdData;
  const currencySymbol = getCurrencySymbol(freelancer.currency);
  
  const doc = new jsPDF();
  
  // Title
  doc.setFontSize(22);
  doc.setTextColor(79, 70, 229);
  doc.text('Project Requirement Document', 20, 20);
  
  // Project name
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text(project.title, 20, 35);
  
  // Metadata
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text(`Client: ${client.name}`, 20, 45);
  doc.text(`Prepared by: ${freelancer.name}`, 20, 52);
  doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, 59);
  doc.text(`Budget: ${currencySymbol}${project.total_budget.toFixed(2)}`, 20, 66);
  
  // Section: Project Overview
  let yPos = 80;
  doc.setFontSize(14);
  doc.setTextColor(79, 70, 229);
  doc.text('1. Project Overview', 20, yPos);
  yPos += 10;
  
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  const overviewText = doc.splitTextToSize(project.description, 170);
  doc.text(overviewText, 20, yPos);
  yPos += (overviewText.length * 7) + 10;
  
  // Section: Objectives
  doc.setFontSize(14);
  doc.setTextColor(79, 70, 229);
  doc.text('2. Project Objectives', 20, yPos);
  yPos += 10;
  
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  const objectives = [
    'Deliver a high-quality solution that meets client requirements',
    'Complete the project within the agreed timeline and budget',
    'Ensure client satisfaction through regular communication',
    'Provide comprehensive documentation and support'
  ];
  objectives.forEach(obj => {
    doc.text(`• ${obj}`, 25, yPos);
    yPos += 7;
  });
  yPos += 5;
  
  // Section: Scope of Work
  doc.setFontSize(14);
  doc.setTextColor(79, 70, 229);
  doc.text('3. Scope of Work', 20, yPos);
  yPos += 10;
  
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  const scopeItems = [
    'Requirements gathering and analysis',
    'Design and development',
    'Testing and quality assurance',
    'Deployment and handover',
    'Post-delivery support'
  ];
  scopeItems.forEach(item => {
    doc.text(`• ${item}`, 25, yPos);
    yPos += 7;
  });
  yPos += 5;
  
  // Section: Timeline
  if (yPos > 240) {
    doc.addPage();
    yPos = 20;
  }
  
  doc.setFontSize(14);
  doc.setTextColor(79, 70, 229);
  doc.text('4. Timeline', 20, yPos);
  yPos += 10;
  
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  if (project.start_date && project.end_date) {
    doc.text(`Start Date: ${project.start_date}`, 25, yPos);
    yPos += 7;
    doc.text(`End Date: ${project.end_date}`, 25, yPos);
    yPos += 7;
  } else {
    doc.text('Timeline to be defined based on project requirements', 25, yPos);
    yPos += 7;
  }
  yPos += 5;
  
  // Section: Deliverables
  doc.setFontSize(14);
  doc.setTextColor(79, 70, 229);
  doc.text('5. Deliverables', 20, yPos);
  yPos += 10;
  
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  const deliverables = [
    'Complete source code and documentation',
    'Deployed application (if applicable)',
    'User manual and technical documentation',
    'Training materials (if required)'
  ];
  deliverables.forEach(item => {
    doc.text(`• ${item}`, 25, yPos);
    yPos += 7;
  });
  
  // Footer
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text('This document is confidential and intended only for the specified client.', 20, 285);
  
  return doc;
};

export const downloadPRD = (prdData, filename) => {
  const doc = generatePRD(prdData);
  doc.save(filename || `PRD_${prdData.project.title.replace(/\s+/g, '_')}.pdf`);
};
